import _ from 'lodash';

import { renderItem } from './RenderItem';

export const mapDetailItem = (column) => {
  return  _.map(column, (detail, index) => renderItem(detail, index));
 };